// export const employee_report = require('./employee_report');
export const employee_year_report = require('./employee_year_report');
export const hour_listing_report = require('./hour_listing_report');
export const hour_salary_report = require('./hourSalaryRowsGeneration');
export const jydacom_salary_report = require('./jydacomSalaryRowsGeneration');

// export const salary_report = require('./salary_report');
// export const week_salary_report = require('./week_salary_report');
// export const work_time_report = require('./work_time_report');
// export const xls_report = require('./xls_report');
